import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { CContainer, CSpinner } from "@coreui/react-pro";

// routes config
import routesKitchen from "../routesKitchen";

const AppContentKitchen = () => {
  return (
    <CContainer lg className="sales px-0">
      <Suspense fallback={<CSpinner color="primary" />}>
        <Switch>
          {routesKitchen.map((route, idx) => {
            return (
              route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={(props) => (
                    <>
                      <route.component {...props} />
                    </>
                  )}
                />
              )
            );
          })}
          {/* <Redirect from="/" to="/dashboard" /> */}
        </Switch>
      </Suspense>
    </CContainer>
  );
};

export default React.memo(AppContentKitchen);
